import styled from 'styled-components';
import Text from 'styles/typography';

export const Wrapper = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: #fff;
  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled(Text)`
  font-size: 32px;
  font-weight: 500;
  line-height: initial;
  color: ${({ theme }) => theme.colors.title};

  & .user {
    color: ${({ theme }) => theme.colors.mainDark};
  }
`;

export const Subtitle = styled(Text)`
  margin-top: 2px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.mainDark};
`;

export const ChildrenContent = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 767px) {
    margin: 15px 0;
  }
`;
